export default __webpack_public_path__ + "static/media/conteudo_extra_08_20.6d6b0793.jpg";